import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export class Selection extends PureComponent {
  static propTypes = {
    style: PropTypes.shape({
      opacity: PropTypes.string,
      fill: PropTypes.string,
      stroke: PropTypes.string,
      strokeWidth: PropTypes.string,
    }),
    points: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  };

  static defaultProps = {
    style: {
      opacity: '0.4',
      fill: '#004',
      stroke: 'black',
      strokeWidth: '3px',
    },
  };

  render() {
    const { style, points } = this.props;

    if (points.length < 3) {
      return null;
    }

    return <polygon points={points.map(p => `${p[0]},${p[1]}`).join(' ')} style={style} />;
  }
}
